// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1NhvO","log":"ModalInventoryLogs_log__2UsiA","date":"ModalInventoryLogs_date__3pcYE","userName":"ModalInventoryLogs_userName__VCK7F"};